/* eslint-disable @typescript-eslint/no-explicit-any */
import { createActions } from "re-reduced";

import {
  AddressType,
  AddressValidated,
  BillEstimatePayload,
  BillEstimateResponse,
  BillingPeriod,
  CommercialProduct,
  EligibilityUpdate,
  fetchProductPayload,
  GetSignUpResponse,
  Product,
  SelectAddressPayload,
  SignUpFormPaymentTypes,
  SignUpResponse,
  UserChecks,
  UserDetails,
  UserPayment,
  UserProperty,
  WindcaveAuthorisation,
  WindcaveTransaction,
} from "./types";

export default createActions("CORE", (create) => ({
  createPlanChooserSignUp: create.asyncAction<AddressValidated, AddressType>(),
  validateAddress: create.asyncAction<AddressValidated, AddressType>(),
  selectAddress: create.action<SelectAddressPayload>(),
  setAddress: create.action<AddressType>(),
  updateEligibility: create.action<EligibilityUpdate>(),
  clearAddress: create.action(),
  clearState: create.action(),
  createFlickSignUp: create.asyncAction<SignUpResponse, void, string>(),
  updateFlickSignUp: create.asyncAction<SignUpResponse, void, string>(),
  fetchProductData: create.asyncAction<any, fetchProductPayload>(),
  setFlickUserId: create.action<string>(),
  getFlickSignUp: create.asyncAction<GetSignUpResponse, string, string>(),
  setFlickSignUpStateComplete: create.action(),
  setCreationSourceIdentifier: create.action(),
  setLeadSource: create.action<string | undefined>(),
  setSignUpPaymentType: create.action<SignUpFormPaymentTypes | undefined>(),
  setCurrentFormStep: create.action<string>(),
  setAvailableProducts: create.action<Product[] | CommercialProduct[]>(),
  setPartialSignUpDialogState: create.action<boolean>(),
  setPromoCode: create.action<string | undefined>(),
  setUserDetails: create.action<UserDetails>(),
  setUserProperty: create.action<UserProperty>(),
  setUserPayment: create.action<UserPayment>(),
  setUserBillingPeriod: create.action<BillingPeriod>(),
  setUserChecks: create.action<UserChecks>(),
  setUserProduct: create.action<Product | CommercialProduct>(),
  createWindcaveTransaction: create.asyncAction<WindcaveTransaction>(),
  checkSuccessfulAuthorisation: create.asyncAction<WindcaveAuthorisation>(),
  fetchBillingEstimate: create.asyncAction<
    BillEstimateResponse,
    BillEstimatePayload
  >(),
  fetchAvailableProducts: create.asyncAction<
    BillEstimateResponse,
    BillEstimatePayload
  >(),
}));
